import { render, staticRenderFns } from "./CommentChoices.vue?vue&type=template&id=00ed8d9c&scoped=true&"
import script from "./CommentChoices.vue?vue&type=script&lang=ts&"
export * from "./CommentChoices.vue?vue&type=script&lang=ts&"
import style0 from "./CommentChoices.vue?vue&type=style&index=0&id=00ed8d9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ed8d9c",
  null
  
)

export default component.exports